import React from 'react'

import {
  getAttackStageReadable,
  isInHaltingStage
} from 'components/attacks/utils/attack-stages'
import { getResolvedHosts } from 'components/attacks/utils/attacks'
import { AttackTypeIcon } from 'components/common/AttackTypeIcon'
import GlyphIcon from 'components/common/GlyphIcon'
import {
  AttackDescription,
  AttackRow,
  TargetsColumn,
  Status,
  HaltButton,
  DetailsChevron
} from 'components/navigation/Notifications/AttackRows/common/AttackRow'
import { IlfiTargets } from 'components/navigation/Notifications/AttackRows/common/Targets'
import useMetadata from 'hooks/use-metadata'
import { InfraAttack } from 'types/api/attacks/details/infra-attack'

export const IlfiAttackRow: React.FC<{
  attack: InfraAttack
  doFetch(): void
  clickableRow?: boolean
  selectableRow?: boolean
  onRowSelected?(): void
  onHaltAttack?(): void
  showHaltButton?: boolean
  checked?: boolean
}> = ({
  attack,
  doFetch,
  clickableRow,
  selectableRow,
  onRowSelected,
  onHaltAttack,
  showHaltButton,
  checked
}) => {
  const commandType =
    attack?.args[0] ?? attack?.infra_command?.commandArgs?.cliArgs[0]
  const { getAttackName } = useMetadata()

  const { guid: attackId } = attack
  const resolvedHosts = getResolvedHosts(attack)
  const isHalting = isInHaltingStage(attack.stage)

  return (
    <AttackRow
      data-active-attack-row
      checked={checked}
      clickableRow={clickableRow}
      selectableRow={selectableRow}
      showHaltButton={showHaltButton}
      to={`/attacks/${attack.guid}`}
      onRowSelected={onRowSelected}
    >
      <AttackDescription
        description={
          isHalting ? (
            'Halting...'
          ) : (
            <Status>
              {getAttackStageReadable(attack.stage)}
              ...
            </Status>
          )
        }
        icon={
          <GlyphIcon>
            <AttackTypeIcon icon={commandType} />
          </GlyphIcon>
        }
        name={getAttackName(commandType)}
      />
      <TargetsColumn>
        <IlfiTargets targets={resolvedHosts} />
      </TargetsColumn>
      {showHaltButton && (
        <HaltButton
          fetchAttack={doFetch}
          isHalting={isHalting}
          trackingOptions={{ AttackId: attackId }}
          onConfirmRequest={onHaltAttack}
        />
      )}
      {clickableRow && <DetailsChevron />}
    </AttackRow>
  )
}
